import { coreInitiativesCommentsGetAsyncSlice } from './get';
import { coreInitiativesCommentsPostAsyncSlice } from './post';

export const { requestGetCoreInitiativesComments, resetGetCoreInitiativesComments } =
	coreInitiativesCommentsGetAsyncSlice.asyncActionCreators;

export const { requestPostCoreInitiativesComments, resetPostCoreInitiativesComments } =
	coreInitiativesCommentsPostAsyncSlice.asyncActionCreators;

export * from './_id/actions';
